import { IconArrowDown, IconCloseCircle } from '@/presentation/components/icons';
import classNames from 'classnames';
import React from 'react';
import Styles from './header-styles.scss';
import { APP_VERSION } from '@/presentation/constants/app-version';
import { activitiesModeAtom } from '@/presentation/components/atoms/atoms-activities';
import { useRecoilValue } from 'recoil';
import { useNavigate } from 'react-router';
import IconButton from '@/presentation/components/icon-button/icon-button';
import BalanceHeader from './balance-header';
import TaskInfoHeader from './taks-info-header';
import useUserSesssion from '@/presentation/hooks/use-user-session';
const HeaderActivities = (props) => {
    const state = useRecoilValue(activitiesModeAtom);
    const navigate = useNavigate();
    const { isCognitoWatcher } = useUserSesssion();
    return (React.createElement("nav", { className: classNames('navbar navbar-expand-lg bg-light sticky-top', Styles.nav) },
        React.createElement("div", { className: "container-fluid" },
            React.createElement("a", { href: "#", className: classNames('navbar-brand', Styles.logoWrap) },
                React.createElement("img", null)),
            React.createElement("div", { style: { fontSize: 8, color: 'gray' } },
                `${process.env.REACT_APP_STAGE || ''} - V. ${APP_VERSION}`,
                isCognitoWatcher && React.createElement("span", { className: "cognito-watcher-title" }, "USER WATCHER ON")),
            React.createElement("button", { className: "navbar-toggler", type: "button", "data-bs-toggle": "collapse", "data-bs-target": "#navbarScroll", "aria-controls": "navbarScroll", "aria-expanded": "false", "aria-label": "Toggle navigation" },
                React.createElement(IconArrowDown, { color: "black" })),
            React.createElement("div", { className: classNames('collapse navbar-collapse', Styles.navbarCollapse), id: "navbarScroll" },
                React.createElement("ul", { className: "navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll" }),
                React.createElement("div", { className: Styles.centerTitle },
                    React.createElement("div", { className: Styles.title }, 'Activity'),
                    React.createElement("div", { className: Styles.subtitle }, state === null || state === void 0 ? void 0 : state.activityTitle)),
                state.showBalanceHeader && React.createElement(BalanceHeader, null),
                state.showTaskInfoHeader && React.createElement(TaskInfoHeader, null),
                React.createElement(IconButton, { onClick: () => navigate(state.returnPath) },
                    React.createElement(IconCloseCircle, null))))));
};
export default HeaderActivities;
